import helpers from './mixins/helpers';
import stream from './stream.js'
if(document.getElementById('stream-admin')){
    let adminStream = new stream({
        mixins: [helpers],
        el:"#stream-admin",
        data:{
            editMessage:null,
            tempMessage:null,
        },
        methods:{
            fixMessage(mid){
                let self = this;
                $.ajax({
                    url:'/lections/stream/fix-message/'+lection_id,
                    type: "POST",
                    data:{
                        _csrf:self.getCsrf(),
                        mid:mid
                    }
                });
            },
            cancelFixMessage(mid){
                let self = this;
                $.ajax({
                    url:'/lections/stream/close-fix-message/'+lection_id,
                    type: "POST",
                    data:{
                        _csrf:self.getCsrf(),
                        mid:mid
                    }
                });
            },
            deleteMessage(mid){
                let self = this;
                if (!confirm("Удалить сообщение?")) return false;

                $.ajax({
                    url:'/lections/stream/remove-msg/'+lection_id,
                    type: "POST",
                    data:{
                        _csrf:self.getCsrf(),
                        mid:mid
                    },
                    error: function(jqXHR,textStatus,errorThrown)
                    {
                        alert(jqXHR.responseJSON.message);
                    }
                });
            },
            cancelLectorMessage(mid){
                let self = this;


                $.ajax({
                    url:'/lections/stream/cancel-lector-msg/'+lection_id,
                    type: "POST",
                    data:{
                        _csrf:self.getCsrf(),
                        mid:mid
                    }
                });

            },
            inputKey(e) {
              if (e.keyCode === 13) {
                  e.preventDefault();
              }
            },
            editLectorMessage(mid){
                let self = this;
                var textField = $('textarea[data-message-id="'+mid+'"]');
                this.messages[mid].message.text = textField.val();
                $.ajax({
                    url:'/lections/stream/edit-lector-msg/'+lection_id,
                    type: "POST",
                    data:{
                        _csrf:self.getCsrf(),
                        mid:mid,
                        msg:this.messages[mid].message.text
                    }
                });

            },
            canselEditLectorMessage(mid) {
                var textField = $('textarea[data-message-id="'+mid+'"]');
                textField.val(this.tempMessage);

            },
            toLectorMessage(mid){
                let self = this;
                $.ajax({
                    url:'/lections/stream/send-lector/'+lection_id,
                    type: "POST",
                    data:{
                        _csrf:self.getCsrf(),
                        mid:mid
                    }
                });

            },
            toggleLector(mid) {
                let self = this;
                if (self.in(mid, this.forLectors)) {
                    this.cancelLectorMessage(mid);
                }
                else {
                    this.toLectorMessage(mid);
                }

            },
            changeStatus(statusId){
                let self = this;
                let statuses = {
                    1:{
                        endpoint:'lection-start',
                        message:'Начать вебинар?'
                    },
                    2:{
                        endpoint:'theory-end',
                        message:'Завершить теоритическую часть?'
                    },
                    3:{
                        endpoint:'lection-completed',
                        message:'Завершить вебинар?'
                    }
                };

                if (confirm(statuses[statusId].message + '\rЭто действие нельзя будет отменить!')){

                    var one =  Math.floor(Math.random() * (9 - 1 + 1)) + 1;

                    var two =  Math.floor(Math.random() * (9 - 1 + 1)) + 1;
                    var result = prompt(statuses[statusId].message+'\rСколько будет '+one +'+'+ two +' ?');

                    if((one + two) == result){
                        $.ajax({
                            url:'/lections/stream/'+statuses[statusId].endpoint+'/'+lection_id,
                            type: "POST",
                            data:{
                                _csrf:self.getCsrf()
                            }
                        });
                    }


                } else{

                    return false;
                }

            },
            startPull(pullId){
                let self = this;
                self.pulls[pullId].is_voted = true;

                $.ajax({
                    url:'/lections/stream/send-pull/'+lection_id,
                    type: "POST",
                    data:{
                        _csrf:self.getCsrf(),
                        pull_id:pullId
                    }

                });
            },
            timer(time){
                     var self = this;
                     var intervalId = setInterval(function () {
                        time--;
                        self.pulls[self.currentPull.id].time =  time;
                        if(time <=0 ) {

                            clearInterval(intervalId);
                            self.currentPull = null;
                        }

                    },1000);

            },
            activeEditorTextarea(mid) {
                var textField = $('textarea[data-message-id="'+mid+'"]');
                this.editMessage = mid;
                this.tempMessage = this.messages[mid].message.text;
                textField.focus()
            }
        }
    });

    Offline.on('confirmed-up',function () {

        adminStream.netMessage = false;
    });

    Offline.on('confirmed-down',function () {

        adminStream.netMessage = true;

    });

}
